import { createContext, useContext } from "react";

import { FilterData } from "@/components/FilterBar/typing";
import { FilterData as RoutesFilterData } from "@/pages/Routes/components/FilterBar/typing";

export const AlertParamsContext = createContext<{
  alertParams?: Partial<FilterData>;
  routesAlertParams?: Partial<RoutesFilterData>;
  setAlertParams: (data?: Partial<FilterData>) => void;
  setRoutesAlertParams: (data?: Partial<RoutesFilterData>) => void;
}>({
  alertParams: undefined,
  routesAlertParams: undefined,
  setAlertParams: () => {
    //
  },
  setRoutesAlertParams: () => {
    //
  },
});

export const useAlertParamsContext = () => {
  return useContext(AlertParamsContext);
};
